import ImageOverlayController from './image_overlay_controller'

export default class extends ImageOverlayController {}
